if (!customElements.get("custom-toggle-product")) {
  customElements.define(
    "custom-toggle-product",
    class CustomToggleProduct extends HTMLElement {
      constructor() {
        super();
        this.initElements();
        this.initData();
        this.initEvents();
      }

      initElements() {
        this.buttons = this.querySelectorAll("button.product-model-btn");
        this.atcButton = this.querySelector(".bundle-btn");
        this.selectedCapsuleId = this.querySelector("select")?.value;
        this.sideCart = document.querySelector("side-cart");
        this.shopPayMessage = document.querySelector("shopify-payment-terms");
        this.market = this.dataset.market;
        this.customUpsellCheckbox = this.querySelector("input#custom-upsell");
        this.customUpsellProductVariantId = this.customUpsellCheckbox?.checked
          ? this.customUpsellCheckbox.value
          : null;
        // console.log("customUpsellProductVariantId:", this.customUpsellProductVariantId);
      }

      initData() {
        const data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        // console.log("2024-custom-toggle-product-bundle-pdp.js", data);
        [this.machineProduct, ...this.capsuleProducts] = data;
      }

      initEvents() {
        if (this.atcButton) {
          this.atcButton.addEventListener("click", this.addBundleProd.bind(this));
        }

        if (this.customUpsellCheckbox) {
          this.customUpsellCheckbox.addEventListener("change", this.handleUpsellChange.bind(this));
        }

        this.addEventListener("change", this.updateBundles.bind(this));
      }

      handleUpsellChange(event) {
        this.customUpsellProductVariantId = event.target.checked ? event.target.value : null;
        // console.log("Upsell checkbox changed:", this.customUpsellProductVariantId);
      }

      updateBundles() {
        this.selectedCapsuleId = this.querySelector("select")?.value;
        this.updateShopPayMessaging(this.selectedCapsuleId);
      }

      updateShopPayMessaging(selectedCapsuleId) {
        if (this.shopPayMessage) {
          this.shopPayMessage.setAttribute("variant-id", selectedCapsuleId);
        }
      }

      async updatePriceByCapsulesSelection(selectedCapsuleHandle) {
        const bundlePriceWithoutDiscounts = document.querySelectorAll(
          ".bundle-price-without-discount"
        );
        const bundlePriceWithDiscounts = document.querySelectorAll(".bundle-price-with-discount");

        const selectedCapsuleProduct = this.capsuleProducts.find(
          (product) => product.handle === selectedCapsuleHandle
        );

        const updatedBundlePrice = (
          (this.machineProduct.price + selectedCapsuleProduct.price) /
          100
        ).toFixed(2);

        bundlePriceWithoutDiscounts.forEach(
          (price) => (price.textContent = `$${updatedBundlePrice}`)
        );
        bundlePriceWithDiscounts.forEach(
          (price) => (price.textContent = `$${(updatedBundlePrice - 40).toFixed(2)}`)
        );
      }

      async addBundleProd() {
        this.updateBundles();

        const bundleProductIds = [this.machineProduct.variants[0].id];

        if (this.selectedCapsuleId) {
          bundleProductIds.push(Number(this.selectedCapsuleId));
        }

        if (this.customUpsellProductVariantId) {
          bundleProductIds.push(Number(this.customUpsellProductVariantId));
        }

        try {
          this.toggleInProgress(true);

          const items = this.createCartItems(bundleProductIds);

          await this.sideCart.addItemsToCart(items);

          setTimeout(() => this.toggleInProgress(false), 1000);
        } catch (err) {
          console.error(err);
          this.toggleInProgress(false);
          alert("An error occurred while adding items to the cart.");
        }
      }

      toggleInProgress(isInProgress) {
        this.atcButton.classList.toggle("inprogress", isInProgress);
      }

      createCartItems(bundleProductIds) {
        return bundleProductIds.map((bundleId) => {
          // console.log("bundleId", bundleId, typeof bundleId);

          const capsuleVariant = this.capsuleProducts
            .flatMap((product) => product.variants)
            .find((variant) => variant.id === bundleId);

          const capsuleCounts = {
            43250198544583: 6, // Classic Collection Favorites Variety Pack (USA & Canada)
            43258953957575: 6, // Classic Collection Favorites Variety Pack (UK)
            44121971884231: 12, // 2024 Advent Calendar
            44436485046471: 4, // Cocktail Sampler Variety Pack
          };

          const properties = capsuleVariant
            ? {
                _showModifiedPricing: true,
                _modifiedPricing: (capsuleVariant.price / 100).toFixed(2),
                _numCapsulesPerBox: capsuleCounts[capsuleVariant.id] || 8,
              }
            : {};

          return {
            quantity: 1,
            id: bundleId,
            properties,
          };
        });
      }
    }
  );
}
